import React from "react";
import ResetPasswordContainer from "../../components/Account/ResetPassword/ResetPasswordContainer";

type Props = {};

const ResetPassword = (props: Props) => {
  return (
    <div className="page">
      <ResetPasswordContainer />
    </div>
  );
};

export default ResetPassword;
